// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CodepenOutlinedSvg from "@ant-design/icons-svg/es/asn/CodepenOutlined";
import AntdIcon from '../components/AntdIcon';

var CodepenOutlined = function CodepenOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: CodepenOutlinedSvg
  }));
};

CodepenOutlined.displayName = 'CodepenOutlined';
export default React.forwardRef(CodepenOutlined);